export const getConfig = (REACT_DOM_ROOT_ID) => {
  const rootEl = document.getElementById(REACT_DOM_ROOT_ID);
  const configJson = rootEl.getAttribute('data-config');
  return JSON.parse(configJson);
}; 